export default {"src":"/_next/static/media/staking_top_right_icon.9fd0f990.svg","height":49,"width":207,"blurWidth":0,"blurHeight":0};